<report-grid-wrapper [header]="header" [accountId]="accountId">
	<vb-ui-data-grid [ngClass]="styles.grid" [rowData]="data$ | async">
		<vb-ui-data-grid-column [field]="'Title'" [headerName]="'VideoTitle' | translate" [sortable]="true" [filter]="true" [cellRenderer]="'highlightText'">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'TotalViews'" [headerName]="'Media_Videos_TotalViews' | translate" [sortable]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'UniqueViews'" [headerName]="'Reports_UniqueViews' | translate" [sortable]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'CompletionRate'" [headerName]="'Reports_CompletionRateInPercentage' | translate" [sortable]="true" [valueFormatter]="notApplicableValueFormatter">
		</vb-ui-data-grid-column>
	</vb-ui-data-grid>
</report-grid-wrapper>
